// GTIN-8/12/13/14 share one check-digit scheme, so the product form and the
// passport QR caption validate through the same helpers rather than each
// carrying its own copy.
export const GTIN_VALID_LENGTHS = [8, 12, 13, 14];

export const hasValidGtinLength = (gtin: string) =>
  GTIN_VALID_LENGTHS.includes(gtin.length);

export const calculateGtinChecksum = (gtinWithoutChecksum: string) => {
  const weightedDigits = gtinWithoutChecksum
    .split('')
    .map(Number)
    .reverse()
    .map((digit, index) => (index % 2 === 0 ? digit * 3 : digit));
  const sum = weightedDigits.reduce((acc, curr) => acc + curr, 0);
  return (10 - (sum % 10)) % 10;
};

export const hasValidGtinChecksum = (gtin: string) =>
  Number(gtin[gtin.length - 1]) === calculateGtinChecksum(gtin.slice(0, -1));

export const isValidGtin = (value?: string | null) => {
  const gtin = (value || '').trim();
  if (!/^\d+$/.test(gtin)) return false;
  if (!hasValidGtinLength(gtin)) return false;
  return hasValidGtinChecksum(gtin);
};
